import { scenarioConstants, entityConstants } from '../constants';
import { recursiveRetrieveAllScenarios } from '../../utils/accountStructure/accountStructureUtils';

const initialState = {
    compilingScenario: false,
    creatingScenario: false,
    creatingScenarioError: null,
    creatingScenarioValues: false,
    creatingScenarioValuesError: null,
    scenarios: new Map(),
    scenariosList: null,
    currentScenario: null,
    compilingScenarioError: null,
    fetchingScenariosList: false,
    fetchingScenariosListError: null,
    gettingScenario: false,
    gettingScenarioError: null,
    creatingValues: false,
    creatingValuesError: null,
    creatingChangeInValuesError: null, 

    deletingScenario: false,
    deletingScenarioIds: new Set(),
    deletingScenarioError: null,
    updatingScenarioValue: false,
    updatingScenarioValueError: null,
    settingScenarioEmpty: false,
    settingScenatioEmptyError: null,
    compilingCurrentScenarioError: null,
    accountsNotExisting: [],
    accountsCircular: [],

    updatingScenarioCurrency: false,
    updatingScenarioCurrencyError: null,

    openingScenario: false,
    openingScenarioError: null,
    scenarioOpenStatus: 'idle', // idle | loading | converging | ready | error

    revision:0,
};

export function scenarios(state = initialState, action) {
    
    const asMap = (m) => (m instanceof Map ? new Map(m) : new Map(Object.entries(m || {})));
    const key = (id) => String(id);
    const toMap = (v) => {
  if (!v) return new Map();
  if (v instanceof Map) return new Map(v);
  if (Array.isArray(v) && Array.isArray(v[0]) && v[0].length === 2) return new Map(v);
  if (typeof v === "object") return new Map(Object.entries(v));
  return new Map();
};
    
    switch (action.type) {

        case scenarioConstants.CREATE_SCENARIO_REQUEST: {
            return {
                ...state,
                creatingScenario:   true,
                scenarioOpenStatus: 'loading',
            };
        }

        case scenarioConstants.CREATE_SCENARIO_SUCCESS: {
            const s = action.parsedScenario;
            if (!s) return { ...state, creatingScenario: false };

            const scenario = {
                compiled:          true,  // backend created it fully compiled
                scenario_id:       s.scenario_id,
                name:              s.name,
                entity_id:         s.entity_id,
                values:            toMap(s.values),
                originalValues:    toMap(s.originalValues ?? s.values),
                roll_up:           toMap(s.roll_up),
                scenario_currency: s.scenario_currency,
                group_currency:    s.group_currency,
            };

            const scenarios = asMap(state.scenarios);
            scenarios.set(String(s.scenario_id), scenario);

            return {
                ...state,
                creatingScenario:   false,
                scenarios,
                currentScenario:    scenario,
                scenarioOpenStatus: 'ready',
                revision:           (state.revision || 0) + 1,
            };

            
        }
        
        case scenarioConstants.CREATE_SCENARIO_FAILURE: {
            return {
                ...state,
                creatingScenario:   false,
                scenarioOpenStatus: 'error',
                
                creatingScenarioError: action.error,
            };
        }


        case scenarioConstants.GET_SCENARIO_REQUEST: {
            return {
                ...state,
                gettingScenario: true,
                gettingScenarioError: null,
                scenarioOpenStatus: state.openingScenario ? 'loading' : state.scenarioOpenStatus,
            };
        }
        case scenarioConstants.GET_SCENARIO_SUCCESS: {
            const scenarios = asMap(state.scenarios);
            const parsedScenario = action.parsedScenario;
            const scenarioId = action.parsedScenario.scenario_id;
            const scenarioCurrency = action.parsedScenario.scenario_currency;
            const groupCurrency = action.parsedScenario.group_currency;

            const scenario = {
                compiled: true,
                scenario_id: scenarioId,
                originalValues: toMap(parsedScenario.originalValues),
                values: toMap(parsedScenario.values),
                roll_up: toMap(parsedScenario.roll_up),
                scenario_currency: scenarioCurrency,
                group_currency: groupCurrency,
            };
            scenarios.set(String(scenarioId), scenario);
            
            return {
                ...state,
                scenarios,
                currentScenario: scenario,
                gettingScenario: false,
                gettingScenarioError: null,
                scenarioOpenStatus: state.openingScenario ? 'converging' : state.scenarioOpenStatus,
                viewCurrencyId: null,
            };
            
        }
        
        case scenarioConstants.GET_SCENARIO_FAILURE: {
            return {
                ...state,
                gettingScenario: false,
                gettingScenarioError: action.error,
                openingScenario: false,
                openingScenarioError: action.error,
                scenarioOpenStatus: 'error',
            };
        }

        case scenarioConstants.GET_SCENARIOS_LIST_REQUEST:
        return { ...state, fetchingScenariosList: true, fetchingScenariosListError: null };

        case scenarioConstants.GET_SCENARIOS_LIST_SUCCESS:
        return { ...state, fetchingScenariosList: false, scenariosList: action.scenariosList };

        case scenarioConstants.GET_SCENARIOS_LIST_FAILURE:
        return { ...state, fetchingScenariosList: false, fetchingScenariosListError: action.error };



        case scenarioConstants.SET_SCENARIOS_NULL_SUCCESS: {
            const newState = { ...state };
            newState.scenarios = new Map();
            newState.currentScenario = null;

            return {
                ...newState,
            };
        }

        case scenarioConstants.COMPILE_CURRENT_SCENARIO_SUCCESS: {
            let newCurrentScenario = { ...state.currentScenario };
            newCurrentScenario.compiled = false;

            return {
                ...state,
                currentScenario: newCurrentScenario,
            };
            
        }
        case scenarioConstants.COMPILE_CURRENT_SCENARIO_FAILURE: {
            return {
                ...state,
                compilingCurrentScenarioError: action.error,
            };
        }

        case scenarioConstants.OPEN_SCENARIO_REQUEST: {
            return {
                ...state,
                openingScenario: true,
                openingScenarioError: null,
                scenarioOpenStatus: 'loading',
                gettingScenarioError: null,
                compilingScenarioError: null,
            };
        }

        case scenarioConstants.OPEN_SCENARIO_SUCCESS: {
            return {
                ...state,
                openingScenario: false,
                openingScenarioError: null,
                scenarioOpenStatus: 'ready',
            };
        }

        case scenarioConstants.OPEN_SCENARIO_FAILURE: {
            return {
                ...state,
                openingScenario: false,
                openingScenarioError: action.error,
                scenarioOpenStatus: 'error',
            };
        }

        case scenarioConstants.CREATE_VALUES_SUCCESS: {
            return {
                ...state,
                scenarios: action.newScenarios,
                creatingValues: false,
                revision: (state.revision || 0) + 1,
            };
        }
        case scenarioConstants.CREATE_VALUES_FAILURE: {
            return {
                ...state,
                creatingValues: false,
                creatingScenarioValuesError: action.error,
            };
        }

        case scenarioConstants.UPDATE_VALUE_REQUEST: {
            return {
                ...state,
                updatingScenarioValue: true,
            };
        }
        case scenarioConstants.UPDATE_VALUE_SUCCESS: {
            const accountNumber =
                action.updatesValues.account.account == null
                    ? action.updatesValues.account.account_number
                    : action.updatesValues.account.account.account_number;

            const originalValues = state.currentScenario.originalValues;
            const existing = originalValues.get(accountNumber) || [];
            const values = [...existing];
          //  const values = [...originalValues.get(accountNumber)];

            const updatedValue = action.updatesValues.updatedValue;       
       

            const index = values.findIndex((value) => value.value_id === updatedValue.value_id);
            const updatedValues = [...values.slice(0, index), updatedValue, ...values.slice(index + 1, values.length)];

            const newCurrentScenario = {
                ...state.currentScenario,
                values: new Map(state.currentScenario.values),
                originalValues: new Map(state.currentScenario.originalValues),
            };
            newCurrentScenario.values.set(accountNumber, updatedValues);
            newCurrentScenario.originalValues.set(accountNumber, updatedValues);

         

            return {
                ...state,
                currentScenario: newCurrentScenario,
                updatingScenarioValue: false,
                revision: (state.revision || 0) + 1,
            };
        }
        case scenarioConstants.UPDATE_VALUE_FAILURE: {
            return {
                ...state,
                updatingScenarioValue: false,
                updatingScenarioValueError: action.error,
            };
        }

        case scenarioConstants.CREATE_SCENARIO_VALUES_REQUEST: {
            return {
                ...state,
                creatingScenarioValues: true,
            };
        }
        case scenarioConstants.CREATE_SCENARIO_VALUES_SUCCESS: {
            return {
                ...state,
                scenarios: asMap(action.scenarios),
                creatingScenarioValues: false,
            };
        }
        case scenarioConstants.CREATE_SCENARIO_VALUES_FAILURE: {
            return {
                ...state,
                creatingScenarioValuesError: action.error,
            };
        }

        case scenarioConstants.DELETE_SCENARIO_REQUEST: {
            const s = new Set(state.deletingScenarioIds);
            s.add(String(action.scenarioId));
            
            return {
                ...state,
                deletingScenario: true,
                deletingScenarioIds: s,
                deletingScenarioError: null 
            };
        }

        case scenarioConstants.DELETE_SCENARIO_SUCCESS: {
            const { scenarioId } = action;
            //const { [scenarioId]: _removed, ...rest } = state.scenarios || {};
            
            const newScenarios = asMap(state.scenarios);    
            newScenarios.delete(key(scenarioId));
            const newCurrent =
            state.currentScenario?.scenario_id?.toString() === key(scenarioId) ? null : state.currentScenario;
            
            const s = new Set(state.deletingScenarioIds);
            s.delete(key(scenarioId));


            return {
                ...state,
                scenarios: newScenarios,
                currentScenario: newCurrent,
                deletingScenario: false,
                deletingScenarioError: null,
                deletingScenarioIds: s,
            };
        }

        case scenarioConstants.DELETE_SCENARIO_FAILURE: {
            const s = new Set(state.deletingScenarioIds);
            s.delete(String(action.scenarioId ?? action.scenario_id));
            return {
                ...state,
                deletingScenario: false, 
                deletingScenarioIds: s,
                deletingScenarioError: action.error ?? 'Delete failed',
            };
        }

        case entityConstants.DELETE_ENTITY_SUCCESS: {
            return {
                ...state,
                scenarios:      action.scenarios ?? state.scenarios,
                currentScenario: action.clearCurrentScenario ? null : state.currentScenario,
            };
        }

        case scenarioConstants.CALCULATE_CONVERGENCE_REQUEST: {
            return {
                ...state,
                compilingScenario: true,
                compilingScenarioError: null,
                scenarioOpenStatus: state.openingScenario ? 'converging' : state.scenarioOpenStatus,
            };
        }
        case scenarioConstants.CALCULATE_CONVERGENCE_SUCCESS: {
            const scenarios = asMap(state.scenarios);
            const scenario = action.compilation.compiledScenario;
            const k = key(scenario.scenario_id);

            scenarios.set(k, scenario);

            const currentScenario =
                state.currentScenario && key(state.currentScenario.scenario_id) === k
                ? { ...scenario }
                : state.currentScenario;

            return {
                ...state,
                compilingScenario: false,
                scenarios, 
                currentScenario,
                compilingScenarioError: null,
                accountsNotExisting: [...action.compilation.accountsNotExisting],
                accountsCircular: [...action.compilation.accountsCircular],
                revision: (state.revision || 0) + 1,
                scenarioOpenStatus: state.openingScenario ? 'converging' : state.scenarioOpenStatus,
                viewCurrencyId: action.compilation.viewCurrencyId ?? state.viewCurrencyId,
                revision: (state.revision || 0) + 1,
                lastConvergeRevision: (state.lastConvergeRevision || 0) + 1,
            };
        }
        case scenarioConstants.CALCULATE_CONVERGENCE_FAILURE: {
            return {
                ...state,
                compilingScenario: false,
                compilingScenarioError: action.error,
                openingScenario: false,
                openingScenarioError: action.error,
                scenarioOpenStatus: 'error',
            };
        }

        case entityConstants.VERIFY_ENTITIES_SUCCESS: {
        const newScenarios = asMap(state.scenarios);
        const entityScenarios = recursiveRetrieveAllScenarios(action.entities, []);

        entityScenarios.forEach((scenario) => {
            const k = key(scenario.scenario_id);
            if (newScenarios.has(k)) {
            const updated = { ...newScenarios.get(k) };
            updated.compiled = false;
            updated.originalValues = new Map();

            scenario.originalValues.forEach((sv) => {
                updated.originalValues.set(sv.scenario_id, sv.values);
            });

            newScenarios.set(k, updated);
            }
        });

        return { ...state, scenarios: newScenarios };
        }

        case scenarioConstants.SET_CURRENT_SCENARIO_NULL_SUCCESS: {
            return {
                ...state,
                currentScenario: null,
            };
        }

        case scenarioConstants.SET_MISSING_ACCOUNTS_OR_CIRCULAR_REFERENCE_SUCCESS: {
            let accountsNotExisting = [...action.businessCase.accountsNotExisting];
            let accountsCircular = [...action.businessCase.accountsCircular];

            return {
                ...state,
                accountsNotExisting: accountsNotExisting,
                accountsCircular: accountsCircular,
            };
        }

        case scenarioConstants.CREATE_CHANGE_IN_VALUES_SUCCESS: {
            const newScenarios = asMap(action.scenarios);
            const newCurrentScenario = newScenarios.get(key(state.currentScenario.scenario_id));
            return { ...state, 
                scenarios: newScenarios, 
                currentScenario: newCurrentScenario,
                revision: (state.revision || 0) + 1, };
        }

        case scenarioConstants.CREATE_CHANGE_IN_VALUES_FAILURE: {
            return {
                ...state,
                creatingChangeInValuesError: action.error,
                
            };
        }

        case scenarioConstants.UPDATE_SCENARIO_SUCCESS: {
            const parsed = action.parsedScenario;
            if (!parsed?.scenario_id) return state;

            const k = key(parsed.scenario_id);
            const scenarios = asMap(state.scenarios);
            const existing = scenarios.get(k);
            if (existing) {
                scenarios.set(k, { ...existing, name: parsed.name });
            }

            const currentScenario =
                state.currentScenario && key(state.currentScenario.scenario_id) === k
                ? { ...state.currentScenario, name: parsed.name }
                : state.currentScenario;

            return {
                ...state,
                scenarios,
                currentScenario,
                // no revision bump — name change shouldn't trigger reconverge or value-driven recalcs
            };
            }

        default: {
            return state;
        }
    }
}
